import React from 'react';

import CollapsableBlockMobile from './CollapsableBlockMobile';

import ChangePasswordForm from '../../../profile/blocks/settings/ChangePasswordForm';

const ChangePasswordBlockMobile = () => {
  return (
    <CollapsableBlockMobile header="Password Settings">
      <ChangePasswordForm isMobile={true} />
    </CollapsableBlockMobile>
  );
};

export default ChangePasswordBlockMobile;
